import store from '../../../store'

export default {
    getValidationSelectOnlyOneAdditionalItem: (state) => state?.settings?.select_only_one_additional_item ?? false,
    getTotalPriceAdditionalItemsSelected: (state) => {
        if(state?.additionalItemsSelected?.items?.length) {
            return state.additionalItemsSelected.items.map(el => Number(el.price)).reduce((ac, curr) => ac + curr, 0)
        } else {
            return 0
        }
    },

    // Mostrar grade de itens
    showItemsGrid: (state) => (
        state?.item?.items_grid_columns_and_rows?.column?.length
        || state?.item?.items_grid_columns_and_rows?.row?.length
        || state?.item?.items_grid?.length
    ),

    maximumAmountOfFlavorsToSelect: (state) => state?.item?.maximum_amount_flavors,
    minimumAmountOfFlavorsToSelect: (state) => state?.item?.minimum_amount_flavors,

    // Retorna os sabores selecionados
    getFlavorsSelected: (state) => state.flavors.filter(flavor => flavor.active),

    // O produto está indisponível
    isProductUnavailable: (state) => {
        if (!state?.item) {
            return false
        }
        if(state.item.pro_stock_site == 0 && state?.item.availability > 0) return false

        return (
            (state.item.pro_stock_site < 1 || state.item.pro_stock_site < state.item.minimum_sale_quantity) &&
            state.item.out_of_stock_unavailable &&
            !state.item.sell_out_of_stock &&
            !state.item.price_on_request &&
            store.state.company.company?.finalizacao_pagamento?.tipo === 'PAGAMENTO'
        );
    },

    // Mostrar preço do produto
    showProductPrice: () => (item) => {
        if (!item) {
            return false;
        }
        let min = (
            item?.quantity_conversion_factor > item?.minimum_sale_quantity ?
            item.quantity_conversion_factor : item.minimum_sale_quantity
        );
        return (
            store.state.company.company?.finalizacao_pagamento?.mostrar_preco &&
            !item.price_on_request &&
            (
                (item.pro_stock_site > 0 && min <= item.pro_stock_site) ||
                item.sell_out_of_stock
            )
        );
    }
}
